<template>
    <v-dialog v-model="dialog" max-width="500px" :persistent="!readonly" >
        <v-card>
            <v-card-title>
                <div class="title">{{isEdition ? (readonly ? 'Ver' : 'Editar') : 'Agregar'}} {{exam && exam.name || getPhysicalExamName}}</div>
            </v-card-title>
            <v-card-text class="py-2">

                <v-form v-if="exam" v-model="valid">
                    <template v-for="(group, groupName) in groupedFields">

                        <div class="group-wrapper" v-if="groupName !== 'ungrouped'" >
                            <span class="group-name">{{groupName}}</span>
                            <v-layout wrap px-1 py-0>
                                <v-flex xs12 md4 py-0 px-1 v-for="(field, j) in group.fields" :key="field.id">
                                    <physical-exam-field
                                            :readonly="readonly"
                                            @change="onFieldChange($event, field.originalIndex)"
                                            :field="field" />
                                </v-flex>
                            </v-layout>
                        </div>
                        <div v-else>
                            <v-layout wrap px-1 py-0>
                                <v-flex xs12 py-0 px-1  v-for="(field, j) in group.fields" :key="field.id">
                                    <physical-exam-field
                                            :readonly="readonly"
                                            @change="onFieldChange($event, field.originalIndex)"
                                            :field="field" />
                                </v-flex>
                            </v-layout>
                        </div>

                    </template>

                </v-form>

            </v-card-text>
            <v-card-actions v-if="!readonly">
                <v-spacer></v-spacer>
                <v-btn color="default" @click="hide">Cancelar</v-btn>
                <v-btn color="primary" :disabled="!valid" @click="attach" :loading="loading">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'
    import {getPhysicalExamName} from "@/utils/Strings";

    import PhysicalExamField from './PhysicalExamField'

    export default{
        components: {
            PhysicalExamField
        },
        props: ['eventId', 'readonly'],
        data(){
            return {
                dialog: false,
                loading: false,
                exam: null,
                valid: false,
                rules: [
                    v => !!v || 'Campo obligatorio'
                ],
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            onFieldChange(val, index){
                var vm = this
                if(vm.isEdition){
                    vm.exam.pivot.values[index].value = val
                }else{
                    vm.exam.physical_exam_fields[index].value = val
                }
            },
            async attach(){
                var vm = this
                var fields = vm.isEdition ? vm.exam.pivot.values : vm.exam.physical_exam_fields

                vm.loading = true
                const response = await ApiUtils.makePost(`exams/physical/attach`, {
                    physical_exam_id: vm.exam.id,
                    schedule_event_id: vm.eventId,
                    values: fields.map(exam => {
                        return {
                            field_name: exam.field_name,
                            value: exam.value
                        }
                    })
                })
                vm.loading = false

                if (response.ok) {
                    const json = await response.json()
                    const attachedItem = json.result.physical_exam
                    vm.isEdition ? vm.$emit('update', attachedItem) :
                            vm.$emit('attach', attachedItem)
                    vm.hide()
                    vm.reset()
                    return
                }

                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando agregar exámen')


            },
            reset(){
                var vm = this
                vm.exam = null
            },
            setDefaults(){
                var vm = this
                if(vm.exam){
                    vm.exam = JSON.parse(JSON.stringify(vm.exam))
                }
            },
            show(exam){
                var vm = this
                vm.exam = exam

                vm.$nextTick(function(){
                    vm.setDefaults()
                    vm.dialog = true
                })
            },
            hide(){
                this.dialog = false
            }
        },
        computed:{
            getPhysicalExamName,
            units(){
                var vm = this
                return [
                    {
                        text: `día${vm.duration > 1 ? 's' : ''}`,
                        value: 'days'
                    },
                    {
                        text: `semana${vm.duration > 1 ? 's' : ''}`,
                        value: 'weeks'
                    },
                    {
                        text: `mes${vm.duration > 1 ? 'es' : ''}`,
                        value: 'months'
                    },
                ]
            },
            isEdition(){
                var vm = this
                return vm.exam && vm.exam.physical_exam_fields === undefined
            },
            groupedFields(){
                var vm = this
                var groups = {}
                const fields = vm.exam.physical_exam_fields || vm.exam.pivot.values
                for(let i in fields){
                    var field = fields[i]
                    var groupName = field.group && field.group.trim() || 'ungrouped'

                    if(!groups[groupName]) {
                        groups[groupName] = {fields:[]}
                    }

                    field.originalIndex = i
                    groups[groupName].fields.push(field)

                }

                return groups
            }
        },
        watch: {
        }
    }
</script>

<style scoped>
    .group-wrapper{
        border: 1px solid #dedcdc;
        border-radius: 5px;
        padding: 5px;
        margin: 5px;
    }

    .group-name{
        margin: 5px;
        font-weight: bold;
    }
</style>
